function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

export var isInternalLink = function isInternalLink(url) {
  return Boolean(url.startsWith('/') && !url.startsWith('//') || !url.startsWith('stash://') && url.match(/\/\/app[a-zA-Z-_]*\.stash\.com/) || url.match(/\/\/app[a-zA-Z-_]*\.stashinvest\.com/) || url.match(/\/\/stash-web-[a-zA-Z-_]*-pr-[0-9]*\.herokuapp\.com/));
};
export var getUrlParts = function getUrlParts(url) {
  if (!url) return {};
  var node = document.createElement('a');
  node.href = url;
  return {
    hash: node.hash,
    host: node.host,
    hostname: node.hostname,
    href: node.href,
    origin: node.origin,
    pathname: node.pathname,
    port: node.port,
    protocol: node.protocol,
    search: node.search
  };
};

var getLinkPropsFromUrl = function getLinkPropsFromUrl(url) {
  if (!url) return {};
  if (_typeof(url) === 'object') return {
    to: url
  };

  var _getUrlParts = getUrlParts(url),
      pathname = _getUrlParts.pathname,
      search = _getUrlParts.search,
      hash = _getUrlParts.hash;

  return isInternalLink(url) ? {
    to: pathname + search + hash
  } : {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer'
  };
};

export default getLinkPropsFromUrl;